
import {Vue, Component} from 'vue-property-decorator';
import {dictApi, dictInstrumentApi, userApi} from "@/api/organization";
const {CodeToText} = require("@/js/region/region");
import baseUrl, {imageUrl} from '@/constants';
import {integrityApi} from "@/api/integrity";
import Credit from "@/views/integrity/Credit.vue";
import SetTableColumns from "@/components/SetTableColumns.vue";
import OrganizationTable2 from "@/components/OrganizationTable2.vue";
import {compressionFile} from "@/common/imageCompress";
import ApplyDialog from "@/views/integrity/applyDialog.vue";

@Component({
  components: {ApplyDialog, Credit,OrganizationTable2}
})

export default class Order extends Vue {
  private tabDataArr = [
    {name: '待提交申请', id: '0', num: 0},
    {name: '已提交申请', id: '1', num: 0},
    {name: '材料待补正', id: '2', num: 0},
    {name: '企业已公示', id: '3', num: 0},
    {name: '企业已撤销', id: '4', num: 0},
    {name: '不受理', id: '5', num: 0},
  ]
  accepts = ['JPEG','JPG', 'PNG']
  private mechanismId = null as any;
  private mechanismDetail= false;//是否展示单位详情
  private industries = [];// 行业列表
  private orders = []; // 已提交申请列表
  private currentIndustry = null as any;
  private activeName = "0";//选中的页签
  CodeToText = CodeToText;
  allSelected = [] as any;
  userData = {}; //当前登陆用户信息

  mounted() {
    this.userData = this.$store.state.AuthedUser;
    //  加载行业列表
    this.getDict();
    //  加载已提交申请
    this.listBySate();
  }

  getNotHandleCount() {
    integrityApi.notHandleCount().then(r => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        this.tabDataArr.map((e: any) => e.num = 0);
        for (const r of rData) {
          const obj = this.tabDataArr.find((e: any) => e.id == r.state);
          if (obj) {
            obj.num += r.count;
          }
        }
      }
    })
  }

  getDict() {
    return dictApi.listDictItem({
      typeCode: "hylb"
    }).then(r => {
      if (r.data.result === 0) {
        this.industries = r.data.data;

      }
    })
  }

  listBySate() {
    //  获取未读任务量
    this.getNotHandleCount();
    var userData = this.$store.state.AuthedUser;
    const params = {
      state: this.activeName,
      org: userData.organizationId
    }
    integrityApi.listBySate(params).then(r => {
      if(r.data.result == 0){
        this.orders = r.data.data;

        this.$nextTick(() => {
          let $table = this.$refs.table as HTMLFormElement;
          if ($table) {
            $table.doLayout();
          }
        })
      }
    })
  }

  handleClick() {
    this.tableClearSelect();
    this.listBySate();
  }

  showOrderCreateDialog(industry: any) {
    const loading = this.$loading({
      text: '正在加载,请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.currentIndustry = industry;
    const params = {typeId: industry.id, typeName: industry.dictValue, typeKey: industry.dictKey};
    integrityApi.addOrUpdate(params).then((r: any) => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        (this.$refs.applyDialog as any).setData(rData);
        this.listBySate();
      }
    }).finally(() => {
      loading.close();
    })
  }

  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }

  tableClearSelect() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }

  showType = 1;

  rightBtn(type: string) {
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (dataArr.length > 1) {
      this.$message.error("只能勾选一条");
      return;
    }
    this.toDetail(dataArr[0], type);
  }

  toDetail(row: any, type: string) {
    // 改变状态  2 待补正 3 已公示 4 已撤销  5 不受理
    if (['2','3','4','5'].indexOf(this.activeName) != -1) {
      integrityApi.changeHandle(row.id).then(() => {
        this.listBySate();
      })
    }
    let type2 = type;
    if (this.activeName == '4') {
      type2 = 'ban'
    }
    (this.$refs.applyDialog as any).toDetail(row, type2);
  }

   showOrg(orgId: string){
    this.mechanismDetail = true;
    this.mechanismId = orgId;
  }
  closeModal() {
    this.mechanismId = "0";
    this.mechanismDetail = false;
  }

  delBtn() {
    if (this.allSelected.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    const ids = this.allSelected.flatMap((e: any) => {
      return e.id
    });

    this.$confirm('此操作将删除/办结, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      integrityApi.deleteIntegrity({ids: ids.join(",")}).then((r: any) => {
        if (r.data.result == 0) {
          this.handleClick();
        }
      });
    }).catch(() => {
      console.log("取消")
    });

  }

  // 企业自己撤销
  revokeBtn() {
    if (this.allSelected.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (this.allSelected.length > 1) {
      this.$message.error("只能勾选一个");
      return;
    }
    this.revokeFun(this.allSelected[0]);
  }
  revokeData = {
    dialog: false,
    data: {} as any,
    revokeReason: ''
  }
  revokeFun(row: any) {
    this.revokeData.data = row;
    this.revokeData.dialog = true;
    this.revokeData.revokeReason = '';
  }
  revokeSubmit() {
    this.$confirm("确实要撤销"+this.revokeData.data.orgName+"的公示吗?", "确认操作").then(() => {
      integrityApi.changeState({id: this.revokeData.data.id, state: 0,revokeReason:this.revokeData.revokeReason}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("提交成功");
          this.revokeData.dialog = false;
          this.handleClick();
        }
      })
    })
  }
}
